import { ColorSAP, Typography } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.DeviceLimitContainer = styled("div")(() => ({
    position: "relative",
    width: "100%",
    height: 475,
    backgroundColor: ColorSAP.neutral[15],
    boxSizing: "border-box",
    padding: "32px 40px 32px 40px",
    borderRadius: 16
}));

Styled.DeviceLimitTypographyNumber = styled(Typography)(() => ({
    letterSpacing: -1.7,
}));

Styled.DeviceLimitTypographyCapacity = styled(Typography)(() => ({
    marginLeft: 6,
    marginTop: 12,
    width: 50,
}));

export default Styled;
